<!-- 模块-站点信息 -->
<template >
  <div>
    <van-image  width="2.5rem" height="2.5rem" fit="cover" radius='5px' :src="data.msg ? data.msg.image.url : '' " @click="go_detail()"></van-image>
    <van-row style="width: calc(100% - 2.8rem); float: right">
      <van-col span="16" class="title" @click="go_detail()">{{data.name}}</van-col>
      <van-col span="8" class="km">{{data.km}}km</van-col>
      <van-col span="16" class="score"><van-rate v-model="data.score.star" readonly /></van-col>
      <van-col span="8" @click="daohang"><icon class="icon" name="daohang"></icon></van-col>
      <van-col span="24" style="color:#999;">电话:{{data.msg.show_pho}}</van-col>
      <van-col span="24"  class="van-ellipsis;" style="color:#999;">{{data.msg.add}}</van-col>
    </van-row>
     <myDetails ref="details" />
  </div>
</template>

<style lang="scss" scoped>
  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    text-overflow:ellipsis;
    white-space: nowrap;
    overflow:hidden;
    margin-top: 2px;
  }

  .km {
    text-align: right;
    font-size: 14px;
    color: #38A1F2
  }

  .score {
    margin-top: 2px;
    line-height: 16px;
  }

  .icon {
    width:35px;
    height:35px;
    float: right;
  }
</style>

<script>
import myDetails from '@/components/site/site_details'

export default {
  name: 'site_template',
  props: ['data'],
  components: {myDetails},
  methods: {
    // 调起导航
    daohang () {
      if (this.data.lat === null) {
        return this.$notify({ type: 'warning', message: '该站点未设置定位信息' })
      }

      global.wx.openLocation({
        latitude: parseFloat(this.data.lat),
        longitude: parseFloat(this.data.lng),
        name: this.data.name,
        address: this.data.msg.add,
        scale: 16
      })
    },

    // 点击跳转详情
    go_detail () {
      this.$refs.details.show(this.data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/site/site_template.vue